import { Component, useContext } from 'react';
import { Button } from 'reactstrap';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileArrowDown } from '@fortawesome/free-solid-svg-icons'

import { AuthenticationContext } from '../../../msal/AuthenticationContext';
import { NotificationContext } from '../../../context/NotificationContext';
import * as apiCalls from '../../../logic/apiCalls';
import { triggerDownloadBlob } from '../../../utils/download';

class DownloadConfigurationButtonInternal extends Component {
    downloadMobotixConfiguration = async () => {
        try {
            console.log("[downloadMobotixConfiguration] Invoking the back-end API to get the Mobotix configuration.");

            const scriptBlob = await apiCalls.getMobotixConfiguration(this.props.authenticationContext, this.props.deviceId);

            triggerDownloadBlob(scriptBlob, 'MobotixConfiguration.cfg');
        }
        catch (err) {
            console.log(`[downloadMobotixConfiguration] Error downloading the Mobotix configuration: ${err}`);
            this.props.notificationContext.setCommunicationFailureNotification(); 
        }
    }

    render() {
        return (<>
                <OverlayTrigger 
            trigger={['hover', 'hover']} // Small work-around to prevent a react-bootstrap warning that 'focus' should be added for touch and keyboard only users.
            placement={this.props.placement || 'right'}
            overlay={
                <Tooltip>
                    {"Download Mobotix Configuration"}
                </Tooltip>
            }
        >
            <Button onClick={this.downloadMobotixConfiguration} color="primary" size="sm" className={this.props.className}>
                <FontAwesomeIcon icon={faFileArrowDown} />
            </Button>
        </OverlayTrigger>  
        </>);
    }
}

export const DownloadConfigurationButton = (props) => {
    const authenticationContext = useContext(AuthenticationContext);   
    const notificationContext = useContext(NotificationContext);
  
    return (
        <DownloadConfigurationButtonInternal authenticationContext={authenticationContext} notificationContext={notificationContext} {...props}/>
    )
}